import React from 'react';
import classNames from 'classnames';
import { useDrop } from 'react-dnd';
import insertTextAtCursor from 'insert-text-at-cursor';
import { connect } from 'react-redux';

import { setNoteTemplate } from '../../../../../_actions/questionnaire.actions';
import { Types } from '../../Types/';

import './style.css';

function cleanNote(note) {
  return note.replace(/Q!\B/g, '');
}

const NoteCanvas = ({ noteTemplate, noteWarning, setNote }) => {
  const [{ canDrop }, drop] = useDrop({
    accept: [...Types, 'first-name', 'last-name', 'age', 'gender'],
    drop: (item) => {
      insertTextAtCursor(document.querySelector("#note-canvas"), `Q!${item.linkId}`);
    },
    collect: (monitor) => ({
      canDrop: monitor.canDrop()
    })
  });

  const canvasStyle = classNames('note-canvas', 'form-control', {
    active: canDrop
  });

  return (
    <div className="row">
      <div className="col-lg-12 mb-2">
        <h5 style={{ borderBottom: '4px solid #1AB2E9' }}>HPI Canvas</h5>
      </div>

      <div className="col-lg-12">
        {noteWarning &&
          <div className="alert alert-danger">The questionnaire was modified. Please review your HPI and question ID order. </div>
        }

        <textarea
          ref={drop}
          onChange={(e) => { setNote(e.target.value) }}
          className={canvasStyle}
          value={noteTemplate || ''}
          id="note-canvas"
          rows="8" />
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    noteTemplate: state.questionnaire.noteTemplate,
    noteWarning: state.questionnaire.noteWarning
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setNote: (note) => { dispatch(setNoteTemplate(cleanNote(note))) }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NoteCanvas);